import { render, staticRenderFns } from "./HotelSelector.vue?vue&type=template&id=188ba928&scoped=true&"
import script from "./HotelSelector.vue?vue&type=script&lang=js&"
export * from "./HotelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ba928",
  null
  
)

export default component.exports